const listaGeneros = [
    {
        value: "1",
        text: "Masculino",
        nemo: "M"
    },
    {
        value: "2",
        text: "Femenino",
        nemo: "F"
    }
  ]
  export default listaGeneros